<section class="pt-60 pb-60 secondary-header-container" *ngIf="width == 'FULL'">
    <div class="container">
        <div class="row">
            <div class="col-12 text-center text-white">
                <h1 class="title">{{ title }}</h1>
                <p class="subtitle mx-auto d-block">{{ subtitle }}</p>
            </div>
        </div>
    </div>
</section>

<div class="container pt-60 pb-60 secondary-header-container" *ngIf="width == 'CONSTRAINED'">
    <div class="row">
        <div class="col-12 text-center text-white">
            <h1 class="title">{{ title }}</h1>
            <p class="subtitle mx-auto d-block">{{ subtitle }}</p>
        </div>
    </div>
</div>